module.exports = __webpack_public_path__ + "static/media/pris-p.f53a4fc1.mp3";